import React from 'react';
import BtnAdd from '../../buttons/BtnAdd';
import { FaSearch } from 'react-icons/fa';


const HeaderSearch = ({ title, searchTerm, funtion }) => {

    return (
        <div className='w-full flex text-2xl font-semibold items-center justify-start gap-2'>
            <div className='w-full flex items-center gap-2'>
                <h1>{title}</h1>
                <div className='flex items-center w-full' >
                    <input
                        placeholder='Buscar ...'
                        value={searchTerm}
                        onChange={funtion}
                        className="w-full outline-none input-bordered focus:outline-none focus:ring-1  text-sm border font-normal p-1 rounded-sm"
                        type="text"
                    />
                </div>
            </div>
        </div>
    );
};

export default HeaderSearch;